import { useState } from 'react';
import { IconButton, Menu, MenuItem, Box } from '@mui/material';
import { MoreVert } from '@mui/icons-material';

interface StatusActionsProps {
  handleEdit?: (product: any) => void;
  handleDelete: (product: any) => void;
  params: any;
  // [30/09] Venda em consulta ou com boleto emitido: o menu nao abre. Antes, Editar e
  // Excluir funcionavam ate no modo consulta - so o botao Adicionar travava.
  disabled?: boolean;
}

export const StatusActions = ({
  params,
  handleDelete,
  handleEdit,
  disabled,
}: StatusActionsProps) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Box className='flex items-center justify-center h-full'>
      <IconButton onClick={handleClick} disabled={disabled}>
        <MoreVert style={{ color: '#D0D7DD' }} />
      </IconButton>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        {handleEdit && (
          <MenuItem
            onClick={() => {
              handleClose();
              handleEdit(params.row);
            }}
          >
            Editar
          </MenuItem>
        )}
        <MenuItem
          onClick={() => {
            handleClose();
            handleDelete(params.row);
          }}
        >
          Excluir
        </MenuItem>
      </Menu>
    </Box>
  );
};
